import type { SVGProps } from "react";
export interface HandSeedlingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HandSeedlingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HandSeedlingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 10V7.613c-1.466.089-2.81-.134-3.882-.835-1.454-.951-2.118-2.583-2.118-4.623 0-.55.397-1.02.939-1.11 1.959-.329 3.644-.227 4.953.713.5.36.903.813 1.233 1.342.33-.529.733-.982 1.233-1.342 1.308-.94 2.994-1.041 4.953-.713.542.09.939.56.939 1.11 0 2.04-.663 3.672-2.118 4.623-1.071.701-2.416.924-3.882.835V10a1.125 1.125 0 1 1-2.25 0M9.453 3.585c-.454-.326-1.131-.516-2.25-.44.16.919.55 1.444 1.02 1.751.511.334 1.28.524 2.355.48-.314-.94-.693-1.48-1.125-1.791m7.343-.44c-1.118-.076-1.795.114-2.249.44-.432.31-.812.85-1.126 1.792 1.075.043 1.845-.147 2.355-.481.47-.307.86-.832 1.02-1.752ZM5.59 11.875c.67 0 1.335.094 1.978.28l3.14.906.197.05q.297.063.602.063h2.284a2.77 2.77 0 0 1 2.737 2.345l2.742-.988.282-.087a2.877 2.877 0 0 1 3.401 1.806l.087.282a2.875 2.875 0 0 1-1.808 3.404l-7.516 2.727a7.63 7.63 0 0 1-6.245-.47l-3.605-1.961a.9.9 0 0 0-.419-.107h-1.43a1.125 1.125 0 0 1 0-2.25h1.43c.522 0 1.036.13 1.494.38l3.605 1.962.257.13a5.38 5.38 0 0 0 4.145.201l7.516-2.727a.625.625 0 0 0 .406-.679l-.03-.123a.626.626 0 0 0-.802-.373l-.001.001-5.258 1.896-.096.035-.002-.002-.032.014a2.8 2.8 0 0 1-.858.134H9.938a1.125 1.125 0 0 1 0-2.25h3.851a.5.5 0 0 0 .159-.024l.045-.017a.525.525 0 0 0-.204-1.009h-2.283c-.481 0-.96-.067-1.422-.2l-3.141-.907a4.9 4.9 0 0 0-1.354-.192H2a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
